import api from "../../../../../api";

export const requestGetUserFilterCount = () => api.get("/userfilter/for/buyer");
